import { Panel } from "../Panel";

export const Sidebar: React.FC = () => (
    <Panel>Menu</Panel>
);